import * as React from "react";
import Button from "@mui/material/Button";
import Menu from "@mui/material/Menu";
import MenuItem from "@mui/material/MenuItem";
import ListItemText from "@mui/material/ListItemText";
import Typography from "@mui/material/Typography";
import Icon1 from "../icons/Icon";
import Space from "../layout/Space";
import PrimaryButton from "../buttons/PrimaryButton";
import Row from "../layout/Row";
import sendDVemail from "../api/sign/sendDVemail";
import { useAppContext } from "../config/AppContext";
import { useSnackbar } from "notistack";
import { getOrRefreshFirebaseToken } from "../config/getFirebaseToken";
import {
  getDocDataByRef,
  getFlutterTime,
  updateDocDataField,
} from "../models/DataFunctions";
import { deleteDoc } from "firebase/firestore";
import downloadFile from "../api/download/downloadFile";
import Modal1 from "../modals/Modal1";
import SendInvoiceToSign from "../folder_modals/SendInvoiceToSign";
import DropSignedDevis from "../folder_modals/DropSignedDevis";
import updateDocDataFieldApi from "../api/database/updateDocDataFieldApi";
import deleteDocApi from "../api/database/deleteDocApi";
import SmallSpinner from "../loading/SmallSpinner";
import CreateFolderFromDevis from "../folder_modals/CreateFolderFromDevis";
import createDocApi from "../api/database/createDocApi";
import { useState } from "react";
import { useEffect } from "react";
import { MenuItemBlock } from "../pages/folder_pages/FoldersAM";
import { isOnlyBasic } from "../hexagone/VisibilityHelpers";
import CreateFolderFromDevisBasic from "../folder_modals/CreateFolderFromDevisBasic";
import DevisPennylane from "../folder_modals/DevisPennylane";

export default function InvoicesAM({
  orgData,
  userData,
  invoiceData,
  handleRefresh,
  navigateWorkspace,
  workspaceData,
  masterData,
  createFolderOpen,
  setCreateFolderOpen,
  setEmailOpen,
}) {
  const { enqueueSnackbar } = useSnackbar();
  const handleClickVariant = (message, variant) => {
    enqueueSnackbar(message, { variant });
  };

  const { appState, setAppState } = useAppContext();
  const prefix = appState.dev ? appState.dev_url : appState.prod_url;
  const [anchorEl, setAnchorEl] = React.useState(null);
  const open = Boolean(anchorEl);
  const [dropSigned, setDropSigned] = React.useState(false);
  const [loadingNewFolder, setLoadingNewFolder] = React.useState(false);
  const [devisPennylaneOpen, setDevisPennylaneOpen] = React.useState(false);
  const handleClick = (event) => {
    setAnchorEl(event.currentTarget);
  };
  const handleClose = () => {
    setAnchorEl(null);
  };

  const handleGoFolder = async () => {
    let folder = await getDocDataByRef(invoiceData.folder_ref);
    if (!folder) {
      handleClickVariant("Le dossier n'existe pas", "error");
      await updateDocDataFieldApi(invoiceData.ref, "folder_ref", null, prefix);
      handleRefresh();
      return;
    } else {
      navigateWorkspace("/folder/" + invoiceData.folder_ref.id);
    }
  };

  const handleDownload = async () => {
    if (!invoiceData.file?.url) {
      handleClickVariant("Le fichier n'est pas disponible", "error");
      return;
    }
    await downloadFile(invoiceData.file, "Devis " + invoiceData.nom);
  };

  const handleDevisPennylane = async () => {
    //return;
    if (!orgData.pennylane?.connected === true) {
      handleClickVariant(
        "Vous n'avez pas activé l'intégration à Pennylane",
        "error"
      );
      navigateWorkspace("/pennylane");
    }
    setDevisPennylaneOpen(true);
    setAnchorEl(null);
  };

  const handleCancel = async () => {
    if (invoiceData.state === "cancelled") {
      handleClickVariant("Le devis est déjà annulé", "error");
      return;
    }
    await updateDocDataFieldApi(invoiceData.ref, "state", "cancelled", prefix);
    handleClickVariant("Devis annulé avec succès", "success");
    handleClose();
    handleRefresh();
  };

  const handleDelete = async () => {
    if (invoiceData.state === "done") {
      handleClickVariant(
        "Vous ne pouvez pas supprimer un devis signé",
        "error"
      );
      return;
    }
    await deleteDocApi(invoiceData.ref, prefix);
    handleClickVariant("Devis supprimé avec succès", "success");
    handleClose();
    navigateWorkspace("/invoices");
  };

  const handleArchive = async () => {
    await updateDocDataFieldApi(invoiceData.ref, "archived", true, prefix);
    handleClickVariant("Devis archivé avec succès", "success");
    handleClose();
    handleRefresh();
  };
  const handleUnArchive = async () => {
    await updateDocDataFieldApi(invoiceData.ref, "archived", false, prefix);
    handleClickVariant("Devis archivé avec succès", "success");
    handleClose();
    handleRefresh();
  };

  const handleDuplicate = async () => {
    let data = invoiceData;
    // remove id and ref
    delete data.id;
    delete data.ref;
    delete data.articles;
    delete data.champs;
    delete data.file;
    data.history_events = [
      {
        date: getFlutterTime(),
        name: "Devis dupliqué",
      },
    ];
    delete data.presign_file;
    delete data.products;
    delete data.signature_details;
    data.state = "draft";

    let new_devis = await createDocApi("devis", data, prefix);
    handleClickVariant("Devis dupliqué avec succès", "success");
    navigateWorkspace("/newinvoicefromdraft/" + new_devis.id);
  };
  const handlModify = () => {
    navigateWorkspace("/newinvoicefromdraft/" + invoiceData.id);
  };

  const [isVisible, setIsVisible] = useState(false);

  useEffect(() => {
    setIsVisible(open);
  }, [open]);

  return (
    <div>
      <Modal1
        isOpen={createFolderOpen}
        onClose={() => setCreateFolderOpen(false)}
      >
        <CreateFolderFromDevis
          orgData={orgData}
          invoiceData={invoiceData}
          onClose={() => setCreateFolderOpen(false)}
          navigateWorkspace={navigateWorkspace}
          masterData={masterData}
        ></CreateFolderFromDevis>
      </Modal1>
      <Modal1 isOpen={dropSigned} onClose={() => setDropSigned(false)}>
        <DropSignedDevis
          orgData={orgData}
          invoiceData={invoiceData}
          onClose={() => setDropSigned(false)}
          handleRefresh={handleRefresh}
        ></DropSignedDevis>
      </Modal1>
      <Modal1
        isOpen={devisPennylaneOpen}
        onClose={() => {
          setDevisPennylaneOpen(false);
        }}
      >
        <DevisPennylane
          devisData={invoiceData}
          forcePageReload={handleRefresh}
          onClose={() => {
            setDevisPennylaneOpen(false);
            handleRefresh();
          }}
          navigateWorkspace={navigateWorkspace}
          orgData={orgData}
          userData={userData}
        ></DevisPennylane>
      </Modal1>
      <PrimaryButton
        id="basic-button"
        aria-controls={open ? "basic-menu" : undefined}
        aria-haspopup="true"
        aria-expanded={open ? "true" : undefined}
        onClick={handleClick}
      >
        <Row x={10}>
          Actions <Icon1 icon_name="menu" fill="white"></Icon1>
        </Row>
      </PrimaryButton>
      {anchorEl && (
        <div>
          <div
            className=" fixed top-0 left-0  bg-transparent h-screen w-screen z-10  "
            onClick={handleClose}
          ></div>
          <div
            id="basic-menu"
            open={open}
            onClose={handleClose}
            className={`bg-white ${isVisible ? "scale-100 opacity-100" : "scale-95 opacity-0"} transition-all duration-300 min-w-c300 w-fit flex-col flex rounded-lg shadow-2xl shadow-shadow_25 l fixed z-20 py-3 px-1   ${false ? "right-10  2.8xl:right-auto" : ""}`}
          >
            <div className={` flex flex-col w-c300 `}>
              <div className="pl-4 pb-2 text-h3 font-light text-pr bg-transparent text-shadow_50">
                ACTIONS RAPIDES
              </div>

              {!workspaceData && invoiceData.state !== "cancelled" && (
                <MenuItemBlock onClick={handlModify}>
                  <div className="">
                    <Icon1 icon_name="modify"></Icon1>
                  </div>
                  <Space x={10} />
                  <div className="flex text-h3">Modifier le devis</div>
                </MenuItemBlock>
              )}
              {invoiceData?.state !== "draft" && (
                <>
                  <MenuItemBlock onClick={handleDownload}>
                    <div className="">
                      <Icon1 icon_name="download"></Icon1>
                    </div>
                    <Space x={10} />
                    <div className="flex  text-h3">Télécharger le devis</div>
                  </MenuItemBlock>
                  {!workspaceData && invoiceData.state !== "done" && (
                    <MenuItemBlock
                      onClick={() => {
                        setEmailOpen(true);
                        handleClose();
                      }}
                    >
                      <div className="">
                        <Icon1 icon_name="share"></Icon1>
                      </div>
                      <Space x={10} />
                      <div className="flex text-h3">
                        Envoyer le devis à signer
                      </div>
                    </MenuItemBlock>
                  )}{" "}
                  {!workspaceData && (
                    <MenuItemBlock onClick={handleDuplicate}>
                      <div className="">
                        <Icon1 icon_name="copy"></Icon1>
                      </div>
                      <Space x={10} />
                      <div className="flex text-h3">Dupliquer le devis</div>
                    </MenuItemBlock>
                  )}
                  {invoiceData.state !== "done" && (
                    <MenuItemBlock
                      onClick={() => {
                        setDropSigned(true);
                        handleClose();
                      }}
                    >
                      <div className="">
                        <Icon1 icon_name="join"></Icon1>
                      </div>
                      <Space x={10} />
                      <div className="flex text-h3">Déposer le devis signé</div>
                    </MenuItemBlock>
                  )}
                  {!workspaceData && (
                    <div>
                      {" "}
                      {false && !invoiceData.archived && (
                        <MenuItemBlock onClick={handleArchive}>
                          <div className="flex flex-grow w-full  flex-row text-h3">
                            <Icon1
                              icon_name="archive"
                              width="18px"
                              height="18px"
                            ></Icon1>
                            <Space x={10} />
                            Archiver
                          </div>
                        </MenuItemBlock>
                      )}
                      {false && invoiceData.archived && (
                        <MenuItemBlock onClick={handleUnArchive}>
                          <div className="flex flex-grow w-full  flex-row text-h3">
                            <Icon1
                              icon_name="archive"
                              width="18px"
                              height="18px"
                            ></Icon1>
                            <Space x={10} />
                            Désarchiver
                          </div>
                        </MenuItemBlock>
                      )}
                      {!invoiceData.folder_ref && (
                        <MenuItemBlock
                          onClick={async () => {
                            setCreateFolderOpen(true);
                            handleClose();
                          }}
                        >
                          <div className="">
                            <Icon1 icon_name="folder"></Icon1>
                          </div>
                          <Space x={10} />
                          <div className="flex  text-h3">
                            Créer un dossier à partir du devis
                          </div>
                        </MenuItemBlock>
                      )}
                      {!workspaceData && (
                        <div
                          className="relative"
                          onClick={handleDevisPennylane}
                        >
                          <MenuItemBlock>
                            <div className="flex flex-grow w-full  flex-row text-h3">
                              <Icon1
                                icon_name="pennylane"
                                width="18px"
                                height="18px"
                                fill="black"
                              />
                              <Space x={12} />
                              Générer devis pennylane
                            </div>
                          </MenuItemBlock>
                        </div>
                      )}
                      {invoiceData.folder_ref && (
                        <MenuItemBlock onClick={handleGoFolder}>
                          <div className="">
                            <Icon1 icon_name="folder"></Icon1>
                          </div>
                          <Space x={10} />
                          <div className="flex  text-h3">Aller au dossier</div>
                        </MenuItemBlock>
                      )}
                    </div>
                  )}
                </>
              )}
              {!workspaceData && (
                <>
                  <MenuItemBlock onClick={handleCancel}>
                    <div className="flex flex-grow w-full  flex-row text-h3">
                      <Icon1
                        icon_name="close"
                        width="18px"
                        height="18px"
                      ></Icon1>
                      <Space x={10} />
                      Annuler le devis
                    </div>
                  </MenuItemBlock>
                  <MenuItemBlock onClick={handleDelete}>
                    <div className="flex flex-grow w-full  flex-row text-h3">
                      <Icon1
                        icon_name="delete"
                        width="18px"
                        height="18px"
                      ></Icon1>
                      <Space x={10} />
                      Supprimer
                    </div>
                  </MenuItemBlock>
                </>
              )}
            </div>
          </div>{" "}
        </div>
      )}
    </div>
  );
}
